import React from 'react'
import { Link } from 'react-router-dom'

function BlogDetailsLeft() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Blog Details Left</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="fw-500"> <Link to="/blog" className="text-custom-white">Blog</Link> </li>
              <li className="active fw-500"> Blog Details </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start Blog --> */}
    <section className="section-padding bg-light-white">
      <div className="container">
        <div className="row">
          <h6 className="d-none">1</h6>
          <aside className="col-lg-4">
            <div className="sidebar_wrap mb-md-80">
              <div className="sidebar">
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Search</h5>
                  </div>
                  <form>
                    <div className="input-group group-form">
                      <input type="search" name="#" className="form-control form-control-custom" placeholder="Search"/>
                      <span className="input-group-append"> <i className="fas fa-search"></i> </span> </div>
                  </form>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Category</h5>
                  </div>
                  <ul className="categories custom">
                    <li> <Link to="#" className="text-custom-black fs-14">All <span className="text-light-dark">(122)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Family <span className="text-light-dark">(26)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Adventure <span className="text-light-dark">(66)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Romantic <span className="text-light-dark">(59)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Wildlife <span className="text-light-dark">(55)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Beach <span className="text-light-dark">(89)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Honey Moon <span className="text-light-dark">(27)</span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">Parks <span className="text-light-dark">(67)</span></Link> </li>
                  </ul>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Popular Post</h5>
                  </div>
                  <ul className="custom popular_post">
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-1.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Repeat predefined chunks</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-2.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Making it look readable</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li className="mb-xl-20">
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-4.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Best Rates For Taxi Service</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="post">
                        <div className="post-wrapper">
                          <div className="popular_post_img animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/blog-3.jpg" className="image-fit" alt="#"/> </Link> </div>
                          <div className="popular_post_title">
                            <h6><Link to="#" className="text-custom-black fs-14">Install App and get free ride</Link></h6>
                            <span className="date text-custom-blue fw-600 fs-14">12 Fab 2024</span> </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Recent Posts</h5>
                  </div>
                  <ul className="popular-post custom resend-banner sidebar-arrow arrow-layout-2">
                    <li className="post-box">
                      <div className="post-img p-relative mb-xl-20"> <Link to="blog-details.php"> <img src="/tm/react/bycycle/assets/images/team-2.jpg" className="full-width" alt="img"/> </Link>
                        <div className="post-meta text-center"> <Link to="#" className="btn-second btn-small mt-3">See All</Link> </div>
                      </div>
                      <p className="mb-xl-50">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    </li>
                    <li className="post-box">
                      <div className="post-img p-relative mb-xl-20"> <Link to="blog-details.php"> <img src="/tm/react/bycycle/assets/images/team-1.jpg" className="full-width" alt="img"/> </Link>
                        <div className="post-meta text-center"> <Link to="#" className="btn-second btn-small mt-3">See All</Link> </div>
                      </div>
                      <p className="mb-xl-50">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                    </li>
                  </ul>
                </div>
                <div className="sidebar_widgets mb-xl-30">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Tags</h5>
                  </div>
                  <div className="tags"> <Link to="#">Car</Link> <Link to="#">Agent</Link> <Link to="#">Family</Link> <Link to="#">Adventure</Link> <Link to="#">Romantic</Link> <Link to="#">Wildlife</Link> <Link to="#">Honeymoon</Link> <Link to="#">Islands</Link> <Link to="#">Parks</Link> </div>
                </div>
                <div className="sidebar_widgets">
                  <div className="widget_title">
                    <h5 className="no-margin text-custom-white">Archive</h5>
                  </div>
                  <ul className="categories custom">
                    <li> <Link to="#" className="text-custom-black fs-14">2010 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2011 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2012 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2013 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2014 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2015 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2016 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2017 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2018 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2019 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                    <li> <Link to="#" className="text-custom-black fs-14">2020 <span className="text-light-dark"><i className="fas fa-arrow-right"></i></span></Link> </li>
                  </ul>
                </div>
              </div>
            </div>
          </aside>
          <div className="col-lg-8">
            <div className="row">
              <div className="col-12">
                <div className="blog-details bx-wrapper bg-custom-white padding-20"> 
                  <article className="post p-relative">
                    <div className="post-wrapper">
                      <div className="post-img animate-img mb-xl-20"> <img src="/tm/react/bycycle/assets/images/slider-2.jpg" className="image-fit" alt="img"/> </div>
                      <div className="blog-meta bg-custom-white">
                        <div className="post-meta-box mb-xl-20">
                          <div className="post-categories"> <Link to="#" className="text-custom-black fs-18">Travel</Link> </div>
                          <div className="post-meta"> <Link to="#" className="text-light-dark mr-2" tabIndex="-1"> <span className="text-custom-blue"> <i className="fas fa-comment"></i> </span> 20 </Link> <Link to="#" className="text-light-dark mr-2" tabIndex="-1"> <span className="text-custom-blue"> <i className="fas fa-thumbs-up"></i> </span> 50 </Link> <Link to="#" className="text-light-dark mr-2" tabIndex="-1"> <span className="text-custom-blue"> <i className="fas fa-eye"></i> </span> 500 </Link>
                          
                          </div>
                        </div>
                        <div className="post-heading p-relative">
                          <h2><Link to="#" className="text-custom-black">Various versions have evole over the years</Link></h2>
                        </div>
                        <div className="post-author mb-xl-20">
                          <div className="author-img animate-img"> <Link to="/blog-details"> <img src="/tm/react/bycycle/assets/images/blog/author-img.png" className="rounded-circle" alt="#"/> </Link> </div>
                          <span className="text-theme fs-14">By <Link to="/blog-details" className="text-custom-black fw-500">Admin</Link></span> </div>
                        <p className="text-light-dark"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
                        <p className="text-light-dark"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>
                        <div className="quote-box mb-xl-20">
                          <blockquote className="bg-light-white"> <span> <i className="fa fa-quote-left text-custom-white"></i> </span>
                            <p className="text-custom-black fs-16 no-margin">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                          </blockquote>
                        </div>
                        <p className="text-light-dark"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
                        <p className="text-light-dark no-margin"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p>
                      </div>
                    </div>
                  </article>
                  <hr/>
                  <div className="post-details-tags-social mb-xl-20">
                    <div className="row no-margin">
                      <div className="col-md-6">
                        <div className="tags-box"> <span className="fs-18 text-light-dark"><i className="fas fa-tags"></i></span>
                          <div className="tags"> <Link to="#">Travel</Link> <Link to="#">Tour</Link> <Link to="#">Agent</Link> </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="social-media-box">
                          <ul className="custom-flex">
                            <li> <Link to="#" className="fb"> <i className="fab fa-facebook-f"></i> </Link> <span className="social-number bg-light-white">500</span> </li>
                            <li> <Link to="#" className="tw"> <i className="fa-brands fa-x-twitter"></i> </Link> <span className="social-number bg-light-white">20</span> </li>
                            <li> <Link to="#" className="fb"> <i className="fab fa-youtube"></i> </Link> <span className="social-number bg-light-white">46</span> </li>
                            <li> <Link to="#" className="bg-custom-blue"> <i className="fas fa-share-alt"></i> </Link> </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="post-author bg-light-white padding-15 mb-xl-20">
                    <div className="author-img animate-img mb-sm-20"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/author-img.png" className="image-fit" alt="author-img"/> </Link> </div>
                    <div className="author-caption">
                      <h5 className="fw-600"><Link to="#" className="text-custom-black">Anna Wright</Link> <span className="text-custom-blue fs-16 ml-2"><i className="fa-brands fa-x-twitter"></i></span></h5>
                      <Link to="#" className="authorpost text-custom-blue fw-600">Most article by this author</Link>
                      <p className="text-light-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                  </div>
                
                  <div className="pagination-btn">
                    <nav>
                      <ul className="pagination">
                        <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                        <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
                      </ul>
                    </nav>
                  </div>
                
                  <div className="comment-box section-padding-top p-relative">
                    <div id="comment-box">
                      <h4 className="text-custom-black fw-600">Reviews [4]</h4>
                      <ul className="comments custom">
                        <li className="comment">
                          <article>
                            <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_1.jpg" className="rounded-circle" alt="comment"/> </div>
                            <div className="comment-content">
                              <div className="comment-meta">
                                <div className="comment-meta-header">
                                  <h5 className="text-custom-black fw-600 author mb-3">Rosalina Pong</h5>
                                  <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">25 Fab 2024</Link> </div>
                                </div>
                                <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                              </div>
                              <div className="comment">
                                <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                              </div>
                            </div>
                          </article>
                        </li>
                        <li className="comment">
                          <article>
                            <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_2.jpg" className="rounded-circle" alt="comment"/> </div>
                            <div className="comment-content">
                              <div className="comment-meta">
                                <div className="comment-meta-header">
                                  <h5 className="text-custom-black fw-600 author mb-3">Brian Wright</h5>
                                  <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">30 Fab 2024</Link> </div>
                                </div>
                                <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                              </div>
                              <div className="comment">
                                <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                              </div>
                            </div>
                          </article>
                          <ul className="children">
                            <li className="comment">
                              <article>
                                <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_3.jpg" className="rounded-circle" alt="comment"/> </div>
                                <div className="comment-content">
                                  <div className="comment-meta">
                                    <div className="comment-meta-header">
                                      <h5 className="text-custom-black fw-600 author mb-3">Sarah Wright</h5>
                                      <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">30 Fab 2024</Link> </div>
                                    </div>
                                    <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                                  </div>
                                  <div className="comment">
                                    <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                  </div>
                                </div>
                              </article>
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <div className="comment-respond" id="respond">
                        <h4 className="text-custom-black fw-600">Leave Comment</h4>
                        <form>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="text-custom-black fw-500 fs-14">Full Name</label>
                                <input type="text" name="#" className="form-control form-control-custom" placeholder="Full Name"/>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="text-custom-black fw-500 fs-14">Email I'd</label>
                                <input type="email" name="#" className="form-control form-control-custom" placeholder="Email I'd"/>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="form-group">
                                <label className="text-custom-black fw-500 fs-14">Comment</label>
                                <textarea rows="4" name="#" className="form-control form-control-custom" placeholder="Comment"></textarea>
                              </div>
                              <button type="submit" className="btn-first btn-submit">Leave Comment</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default BlogDetailsLeft